import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { signOut } from '@futrli/auth';
import { GO_BACK_PREFIX, ErrorTracker } from '@futrli/shared-services';
import { clearPendoSession } from '@futrli/tracking';

import { EXIT_SETTINGS_KEY } from '../core/constants';

const USERS_SETTINGS_FILTER_KEY = 'users-settings-filters';
const INVOICES_BILLS_FILTER_KEY = 'invoices-bills-filters';
const PERFORMANCE_COMPARISON_FILTER_KEY = 'performance-comparison-filters';
const EXPORTED_PDFS_FILTER_KEY = 'exported-pdfs-filters';
const SCHEDULED_REPORTS_FILTER_KEY = 'scheduled-reports-filters';
const AWAITING_REVIEW_FILTER_KEY = 'awaiting-review-filters';
const SENT_PDFS_FILTER_KEY = 'sent-pdfs-filters';

export const useLogout = () => {
  const dispatch = useDispatch();

  const logout = useCallback(async () => {
    await dispatch(signOut());

    localStorage.removeItem(USERS_SETTINGS_FILTER_KEY);
    localStorage.removeItem(INVOICES_BILLS_FILTER_KEY);
    localStorage.removeItem(PERFORMANCE_COMPARISON_FILTER_KEY);
    localStorage.removeItem(EXPORTED_PDFS_FILTER_KEY);
    localStorage.removeItem(SCHEDULED_REPORTS_FILTER_KEY);
    localStorage.removeItem(AWAITING_REVIEW_FILTER_KEY);
    localStorage.removeItem(SENT_PDFS_FILTER_KEY);

    // reset feature flag properties
    //   if (ldClient) {
    //     const defaultLDUser = await getDefaultLaunchDarklyUser();

    //     ldClient.identify(defaultLDUser);
    //     ldClient.flush();
    //   }

    localStorage.removeItem(`${GO_BACK_PREFIX}:${EXIT_SETTINGS_KEY}`);
    sessionStorage.clear();

    clearPendoSession();
    // clean Sentry scope
    ErrorTracker.cleanScope();
  }, [dispatch]);

  return {
    logout
  };
};
